<ion-header class="header --transparent --w-back-button">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-list class="breadcrumb">
        <ion-item
          *ngFor="let breadcrumb of breadcrumbs"
          class="breadcrumb__item"
          [routerLink]="[breadcrumb.link]"
          routerDirection="back"
          detail="false"
        >
          <span [innerHTML]="breadcrumb.name"></span> <span class="breadcrumb__item__dash">/</span>
        </ion-item>
      </ion-list>
      <ion-back-button [defaultHref]="defaultHref" text="" icon="arrow-back-outline" class="--m-white"></ion-back-button>
    </ion-buttons>
    <ion-title>
      <span [innerHTML]="(step$ | async)?.name"></span>
    </ion-title>
    <ion-buttons slot="end">
      <ion-menu-button class="header__burger" icon="menu-outline" autoHide="false"></ion-menu-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <app-challenge-layout [challengeSteps]="steps$ | async" [selected]="step$ | async" (stepChanged)="stepChanged($event)">
    <div
      class="challenge__header"
      [appBackgroundImage]="(step$ | async)?.videoUrl ? undefined : (learningModule$ | async) | learningModulesDefaultImage:(chapter$ | async):(challenge$ | async):(step$ | async)"
    >
      <ng-container *ngIf="(step$ | async)?.videoUrl; let source">
        <video #video controls><source [src]="source" /></video>
      </ng-container>
    </div>

    <div class="challenge__content">
      <span class="challenge__content__title --top">
        <span class="challenge__content__title__icon" [innerHTML]="(step$ | async)?.emoji"></span>
        <span [innerHTML]="(step$ | async)?.name"></span>
      </span>

      <ion-list *ngIf="(step$ | async)?.attachments; let attachments" class="challenge__content__attachments">
        <ion-item *ngFor="let attachment of attachments" lines="none" (click)="openFile(attachment)">
          <ion-icon slot="start" name="document-outline"></ion-icon>
          <ion-text [innerHTML]="attachment.name"></ion-text>
        </ion-item>
      </ion-list>

      <span class="challenge__content__text --large --left" [innerHTML]="(step$ | async)?.content"></span>
      <div class="challenge__content__buttons">
        <ion-button
          *ngIf="(stepId$ | async | isLastStepOfChallenge:(challengeId$ | async) | async) && (challenge$ | async)?.surveyId; else finishChallengeButton"
          class="button --primary"
          [innerHTML]="'LEARNING_MODULES.DO_SURVEY' | translate"
          (click)="openSurvey()"
        ></ion-button>

        <ng-template #finishChallengeButton>
          <ion-button
            *ngIf="(stepId$ | async | isLastStepOfChallenge:(challengeId$ | async) | async); else finishChapterButton"
            class="button --primary"
            [innerHTML]="'LEARNING_MODULES.FINISH_CHALLENGE' | translate"
            (click)="finishChallenge()"
          ></ion-button>
        </ng-template>

        <ng-template #finishChapterButton>
          <ion-button
            *ngIf="false; else finishStepButton"
            class="button --primary"
            [innerHTML]="'LEARNING_MODULES.FINISH_CHAPTER' | translate"
            (click)="finishChapter()"
          ></ion-button>
        </ng-template>

        <ng-template #finishStepButton>
          <ion-button class="button --primary" [innerHTML]="'LEARNING_MODULES.NEXT_STEP' | translate" (click)="next()"></ion-button>
        </ng-template>
      </div>
    </div>
  </app-challenge-layout>
</ion-content>
